const getters = {
  getByProperty: state => (prop, value) =>
    state.list.find(v => v[prop] == value),
  getById: state => id => getters.getByProperty(state)("id", id),
  filterByProperty: state => (prop, value) =>
    state.list.filter(v => v[prop] == value),
  innerJoin: (state, getters, rootState, rootGetters) => (
    joinModuleKey,
    targetProp
  ) => {
    const joinModuleState = rootState["_rest_" + joinModuleKey];

    if (!joinModuleState) return [];

    return state.list
      .map(item => {
        const newItem = { ...item };

        newItem[targetProp] = rootGetters[`_rest_${joinModuleKey}/getById`](
          newItem[targetProp]
        );

        return newItem;
      })
      .filter(newItem => newItem[targetProp]);
  },
  leftJoin: (state, getters, rootState, rootGetters) => (
    joinModuleKey,
    targetProp
  ) => {
    const joinModuleState = rootState["_rest_" + joinModuleKey];

    if (!joinModuleState) return [];

    return state.list.map(item => {
      const newItem = { ...item };

      newItem[targetProp] = rootGetters[`_rest_${joinModuleKey}/getById`](
        newItem[targetProp]
      );

      return newItem;
    });
  }
};

export default getters;
